import React from 'react'
import PropTypes from 'prop-types'

const PanelInformationItem = ({twoColumns, title, text}) => {
  return (
    <div className={`s-column ${twoColumns && 's-cols-2'}`}>
      <p className="s-mb-0 s-color-light-text small">{title}</p>
      <p className="s-mb-0 s-color-lighter-text smaller">{text}</p>
    </div>
  );
};

PanelInformationItem.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  twoColumns: PropTypes.bool,
}

PanelInformationItem.defaultProps = {
  twoColumns: false,
}

export default PanelInformationItem

